export function processUrlForDemo(lookup: string): string {
  let newLookup = lookup;
  if (lookup.includes("parrot")) {
    newLookup = lookup.replace("parrot", "paschal");
  } else if (lookup.includes("reindeer")) {
    newLookup = lookup.replace("reindeer", "randazzo");
  } else if (lookup.includes("hawk")) {
    newLookup = lookup.replace("hawk", "hoffmann");
  }
  return newLookup;
}
